"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.VEHICLE_SELECTOR_BY_YEAR_QUERY = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _get3 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _reactRedux = require("react-redux");
var _qsLite = _interopRequireDefault(require("qs-lite"));
var _commonSetLocation = require("@mmc/common-set-location");
var _commonLoader = require("@mmc/common-loader");
var _commonErrorMessage = require("@mmc/common-error-message");
var _commonCta = require("@mmc/common-cta");
var _clsx = _interopRequireDefault(require("clsx"));
var _reactRouter = require("react-router");
var _formElements = require("@mmc/form-elements");
var _legalTextBlock = require("@mmc/legal-text-block");
var _reactApollo = require("react-apollo");
var types = _interopRequireWildcard(require("./vehicle-selector.prop-types"));
var _vehicleCard = _interopRequireDefault(require("./vehicle-card"));
var _vehicleSelector2 = _interopRequireDefault(require("./vehicle-selector.css"));
var _enterCodeOverlay = require("./enter-code/enter-code-overlay");
var _vehicle = require("./vehicle.utils");
var _templateObject, _CommonLoader;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VEHICLE_SELECTOR_BY_YEAR_QUERY = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  query ContentPage(\n    $market: String!\n    $language: String!\n    $path: String!\n    $year: [String]\n    $ctas: String\n  ) {\n    getPaymentVehicleSelectorByModelYear(\n      market: $market\n      lang: $language\n      path: $path\n      year: $year\n      ctas: $ctas\n    ) {\n      vehicles {\n        vehicleName\n        vehicleCode\n        vehicleYear\n        imagePath\n        imageAltText\n        MSRP\n        isActive\n        configuratorURL\n        vehicleNextGenConfigurator\n        price {\n          value\n          displayValue\n          zeroMessage\n        }\n      }\n    }\n  }\n"])));
exports.VEHICLE_SELECTOR_BY_YEAR_QUERY = VEHICLE_SELECTOR_BY_YEAR_QUERY;
var VehicleSelector = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(VehicleSelector, _React$PureComponent);
  VehicleSelector.resourceType = function resourceType() {
    return 'VehicleSelector_1_0_0';
  };
  function VehicleSelector(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      selectedYear: '',
      showEnterCodeOverlay: false
    };
    _this.getVehicleURL = _this.getVehicleURL.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleYearChange = _this.handleYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEnterCodeClick = _this.handleEnterCodeClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEnterCodeCloseClick = _this.handleEnterCodeCloseClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = VehicleSelector.prototype;
  _proto.handleYearChange = function handleYearChange(event) {
    var value = event.target.value;
    this.setState(function () {
      return {
        selectedYear: value
      };
    });
  };
  _proto.handleEnterCodeClick = function handleEnterCodeClick() {
    this.setState({
      showEnterCodeOverlay: true
    });
  };
  _proto.handleEnterCodeCloseClick = function handleEnterCodeCloseClick() {
    this.setState({
      showEnterCodeOverlay: false
    });
  };
  _proto.getVehicleURL = function getVehicleURL(vehicle) {
    if (!vehicle.isActive) {
      return '';
    }
    var configuratorCodeEntryLabel = this.props.data.configuratorCodeEntryLabel;
    return configuratorCodeEntryLabel ? vehicle.configuratorURL : this.getPaymentCalculatorURL(vehicle);
  };
  _proto.getPaymentCalculatorURL = function getPaymentCalculatorURL(vehicle) {
    var _this$props = this.props,
      paymentCalculatorRedirectLink = _this$props.data.paymentCalculatorRedirectLink,
      market = _this$props.market,
      language = _this$props.language;
    var query = {
      market: market,
      language: language,
      paymentVehicle: vehicle.vehicleCode,
      paymentYear: vehicle.vehicleYear,
      component: 'payment-calc'
    };
    return paymentCalculatorRedirectLink + "?" + _qsLite["default"].stringify(query);
  };
  _proto.renderVehicle = function renderVehicle(vehicleList, theme, msrpDisclaimer, ngcLabel, addPriceDisclaimer, priceDisclaimerId, disclaimerData) {
    var _this2 = this;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme.row, _vehicleSelector2["default"].vehiclesContainer)
    }, vehicleList.vehicles.map(function (vehicle, index) {
      return /*#__PURE__*/_react["default"].createElement(_vehicleCard["default"]
      // eslint-disable-next-line react/no-array-index-key
      , {
        key: vehicle.vehicleName + "-" + index,
        vehicle: vehicle,
        theme: theme,
        msrpDisclaimer: msrpDisclaimer,
        ngcLabel: ngcLabel,
        isNgc: vehicle.vehicleNextGenConfigurator,
        to: _this2.getVehicleURL(vehicle),
        className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-6'], theme['col-lg-4'], _vehicleSelector2["default"].vehicle, vehicle.isActive && _vehicleSelector2["default"].available),
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId,
        disclaimerData: disclaimerData
      });
    }));
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props2 = this.props,
      theme = _this$props2.theme,
      data = _this$props2.data,
      market = _this$props2.market,
      language = _this$props2.language,
      path = _this$props2.path,
      router = _this$props2.router;
    var _this$state = this.state,
      selectedYear = _this$state.selectedYear,
      showEnterCodeOverlay = _this$state.showEnterCodeOverlay;
    var configuratorCodeEntryError = data.configuratorCodeEntryError,
      configuratorCodeEntryHeadingText = data.configuratorCodeEntryHeadingText,
      configuratorCodeEntryLabel = data.configuratorCodeEntryLabel,
      configuratorCodeEntryPlaceholder = data.configuratorCodeEntryPlaceholder,
      configuratorCodeEntryTooltip = data.configuratorCodeEntryTooltip,
      configuratorRetrieveHeadingText = data.configuratorRetrieveHeadingText,
      configuratorCodeEntryContinue = data.configuratorCodeEntryContinue,
      configuratorCodeEntryStartNew = data.configuratorCodeEntryStartNew,
      configuratorErrorMessageHeading = data.configuratorErrorMessageHeading,
      configuratorErrorMessage = data.configuratorErrorMessage,
      disclaimerList = data.disclaimerList,
      disclaimerLabel = data.disclaimerLabel,
      errorTitle = data.errorTitle,
      errorContent = data.errorContent,
      viewHomePage = data.viewHomePage,
      viewHomePagePath = data.viewHomePagePath,
      addPriceDisclaimer = data.addPriceDisclaimer,
      priceDisclaimerId = data.priceDisclaimerId,
      disclaimerData = data.disclaimerData,
      zipCodeHeadingText = data.zipCodeHeadingText,
      zipCodeLabel = data.zipCodeLabel;
    var ngcLabel = data.customizedLabel || 'New 3D Customizer';
    var queryVariables = {
      market: market,
      language: language,
      path: path,
      year: selectedYear ? [selectedYear] : [],
      ctas: typeof data.configuratorCtas !== 'undefined' ? data.configuratorCtas : null
    };
    var msrpDisclaimer = _vehicle.vehicleUtils.getDisclaimer(disclaimerList, 'msrp');
    var LegalTextBlockVehicleSelector = {
      disclaimerLabel: disclaimerLabel,
      useAccordion: true,
      disclaimerList: disclaimerList
    };
    var CommonErrorMessageVehicleSelector = {
      errorTitle: 'Sorry. Finance can’t be shown at the moment.',
      errorContent: 'Rest assured our top engineers are looking into it. Meanwhile, please try again.',
      viewHomePage: 'View homepage',
      viewHomePagePath: '#'
    };
    var _get2 = (0, _get3["default"])(router, 'location.query'),
      paymentVehicle = _get2.paymentVehicle;
    if (paymentVehicle) return null;
    var shouldRenderCodeEntry = configuratorCodeEntryHeadingText && configuratorCodeEntryTooltip && configuratorRetrieveHeadingText;
    var isCA = market === 'ca';
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-md-offset-1'], theme['col-md-10'], _vehicleSelector2["default"].vehicleSelector)
    }, isCA && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-offset-2'], theme['col-sm-8'])
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: _vehicleSelector2["default"].locationTitle
    }, zipCodeHeadingText), /*#__PURE__*/_react["default"].createElement(_commonSetLocation.CommonSetLocationForm, {
      className: _vehicleSelector2["default"].location,
      data: {
        useCurrentLocationLabel: language !== 'fr' ? 'USE CURRENT LOCATION' : 'UTILISER L’EMPLACEMENT ACTUEL',
        inputLocationLabel: zipCodeLabel
      },
      dark: false,
      padding: false,
      theme: theme
    }))), data.modelYear && data.modelYear.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _vehicleSelector2["default"].modelYearContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _vehicleSelector2["default"].tabButtonContainer + " " + theme['col-xs-12']
    }, /*#__PURE__*/_react["default"].createElement(_formElements.InputGroup, null, data.modelYear.map(function (year) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        key: year.id,
        name: year.year,
        value: year.year,
        className: _vehicleSelector2["default"].tabButton + " " + (selectedYear === year.year ? _vehicleSelector2["default"].tabButtonActive : _vehicleSelector2["default"].tabButtonRegular),
        onClick: _this3.handleYearChange
      }, year.year);
    })))), /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: VEHICLE_SELECTOR_BY_YEAR_QUERY,
      variables: queryVariables
    }, function (_ref) {
      var loading = _ref.loading,
        vehicleData = _ref.data,
        error = _ref.error;
      var vehiclesList = vehicleData && vehicleData.getPaymentVehicleSelectorByModelYear;
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_commonErrorMessage.CommonErrorMessage, {
          theme: theme,
          errorTitle: errorTitle || CommonErrorMessageVehicleSelector.errorTitle,
          errorContent: errorContent || CommonErrorMessageVehicleSelector.errorContent,
          viewHomePage: viewHomePage || CommonErrorMessageVehicleSelector.viewHomePage,
          viewHomePagePath: viewHomePagePath || CommonErrorMessageVehicleSelector.viewHomePagePath
        });
      }
      return loading ? _CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null)) : _this3.renderVehicle(vehiclesList, theme, msrpDisclaimer, ngcLabel, addPriceDisclaimer, priceDisclaimerId, disclaimerData);
    })), shouldRenderCodeEntry && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      classes: [_vehicleSelector2["default"].enterCodeBtn],
      theme: theme,
      data: {
        priority: 'low',
        label: configuratorCodeEntryLabel
      },
      clickEvent: this.handleEnterCodeClick
    }), /*#__PURE__*/_react["default"].createElement(_enterCodeOverlay.EnterCodeOverlay, {
      onClose: this.handleEnterCodeCloseClick,
      show: showEnterCodeOverlay,
      theme: theme,
      enterCodePopup: {
        codeEntryHeadingText: configuratorCodeEntryHeadingText,
        codeEntryPlaceholder: configuratorCodeEntryPlaceholder,
        codeEntryErrorMessage: configuratorCodeEntryError,
        continueLabel: configuratorCodeEntryContinue,
        startNewLabel: configuratorCodeEntryStartNew,
        codeEntryTooltip: configuratorCodeEntryTooltip,
        promptHeadingText: configuratorRetrieveHeadingText,
        promptErrorMessageHeading: configuratorErrorMessageHeading,
        promptErrorMessage: configuratorErrorMessage
      },
      countryCode: market,
      market: market,
      language: language
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_legalTextBlock.LegalTextBlock, {
      data: LegalTextBlockVehicleSelector,
      theme: theme
    })));
  };
  return VehicleSelector;
}(_react["default"].PureComponent);
VehicleSelector.displayName = 'VehicleSelector';
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    language: props.language || state.Config.language,
    market: props.market || state.Config.market,
    path: props.path || state.Config.path
  };
};
var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(VehicleSelector));
exports["default"] = _default;